import classNames from 'classnames';
export default function FlagPolandIcon({ size = 24, className }) {
    return (<svg width={(size * 8) / 5} height={size} viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames(className)}>
      <rect x="0" y="0" width="32" height="10" fill="#ffffff"/>
      <rect x="0" y="10" width="32" height="10" fill="#dc143c"/>
    </svg>);
}
